import { app } from '../../app';
import { BlockEntity } from '../../entities/BlockEntity';
import { GameScene } from '../../GameScene';
import { mapGetPan } from '../../util/mapTools';
import { IEffect } from './IEffect';
import { MergeEffect } from './MergeEffect';
import { RocketEffect } from './RocketEffect';

// types
//-----------------------------------------------------------------------------
export type RocketRocketComboEffectOptions = {
  subject: BlockEntity;
  pair: BlockEntity[];
  all: BlockEntity[];
};

/*
    rocket+rocket combo launch effect
*/
export class RocketRocketComboEffect implements IEffect {
  // fields
  //-------------------------------------------------------------------------
  // input
  private readonly _scene: GameScene;
  private readonly _options: RocketRocketComboEffectOptions;

  // init
  //-------------------------------------------------------------------------
  constructor(scene: GameScene, options: RocketRocketComboEffectOptions) {
    this._scene = scene;
    this._options = options;
  }

  // impl
  //-------------------------------------------------------------------------
  public async execute() {
    const position = this._options.subject.c.position.mapPosition;

    // play sound
    app.sound.play('puzzle-combo-rocket-rocket', { pan: mapGetPan(position) });

    // merge all blocks
    await new MergeEffect(this._scene, this._options.all, position).execute();

    // execute horizontal rocket effect
    const horizontalEffect = new RocketEffect(this._scene, {
      position,
      axis: 'horizontal',
    }).execute();

    // execute vertical rocket effect
    const verticalEffect = new RocketEffect(this._scene, {
      position,
      axis: 'vertical',
    }).execute();

    // wait on both effects
    await Promise.all([horizontalEffect, verticalEffect]);
  }
}
